import { IOptions } from "../../types";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EMobileActiveTab, DEFAULT_OPTIONS } from "../../common/constant";
import { apiFetchGraphs } from "../../common/request";
import { setOptionsToLocal } from "../../common/storage";

export interface InitialState {
  options: IOptions;
  roomConnected: boolean;
  agentConnected: boolean;
  rtmConnected: boolean;
  language: "en-US" | "zh-CN" | "ko-KR" | "ja-JP";
  voiceType: "male" | "female";
  selectedGraphId: string;
  graphList: string[];
  mobileActiveTab: EMobileActiveTab;
}

const getInitialState = (): InitialState => {
  return {
    options: DEFAULT_OPTIONS,
    roomConnected: false,
    agentConnected: false,
    rtmConnected: false,
    language: "en-US",
    voiceType: "male",
    selectedGraphId: "",
    graphList: [],
    mobileActiveTab: EMobileActiveTab.AGENT,
  };
};

export const globalSlice = createSlice({
  name: "global",
  initialState: getInitialState(),
  reducers: {
    setOptions: (state, action: PayloadAction<Partial<IOptions>>) => {
      state.options = { ...state.options, ...action.payload };
      setOptionsToLocal(state.options);
    },
    setRoomConnected: (state, action: PayloadAction<boolean>) => {
      state.roomConnected = action.payload;
    },
    setRtmConnected: (state, action: PayloadAction<boolean>) => {
      state.rtmConnected = action.payload;
    },
    setAgentConnected: (state, action: PayloadAction<boolean>) => {
      state.agentConnected = action.payload;
    },
    setLanguage: (state, action: PayloadAction<"en-US" | "zh-CN" | "ko-KR" | "ja-JP">) => {
      state.language = action.payload;
    },
    setSelectedGraphId: (state, action: PayloadAction<string>) => {
      state.selectedGraphId = action.payload;
    },
    setGraphList: (state, action: PayloadAction<string[]>) => {
      state.graphList = action.payload;
    },
    setVoiceType: (state, action: PayloadAction<"male" | "female">) => {
      state.voiceType = action.payload;
    },
    setMobileActiveTab: (state, action: PayloadAction<EMobileActiveTab>) => {
      state.mobileActiveTab = action.payload;
    },
    reset: (state) => {
      Object.assign(state, getInitialState());
    },
  },
});

// Initialize graph data
export const initializeGraphData = createAsyncThunk(
  "global/initializeGraphData",
  async (_, { dispatch }) => {
    const fetchedGraphs = await apiFetchGraphs();
    dispatch(setGraphList(fetchedGraphs.map((graph: any) => graph.id)));
  }
);

export const {
  reset,
  setOptions,
  setRoomConnected,
  setAgentConnected,
  setRtmConnected,
  setVoiceType,
  setLanguage,
  setSelectedGraphId,
  setGraphList,
  setMobileActiveTab,
} = globalSlice.actions;

export default globalSlice.reducer;
